import { render, staticRenderFns } from "./EditDatasetDetail.vue?vue&type=template&id=68b6432b"
import script from "./EditDatasetDetail.vue?vue&type=script&lang=js"
export * from "./EditDatasetDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports